<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AwPbyf/tc-custom/9781944728489.jpg?1705003726531" alt="This image is the cover for the book Frostbite, The Modern Knights Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frostbite, The Modern Knights Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A down on his luck wizard-for-hire must save his new boss from a deadly ice demon in this urban fantasy novel for fans of Jim Butcher and Benedict Jacka. </b><br/><br/> Colin Fisher is a young man with a lot of problems on his plate: a dying father, a dead car doubling as a home, and a mysteriously disappeared fiancée. You’d think with a magical inclination he’d be able to turn it all around, but not so much.<br/><br/> Yet his bad luck appears to be on the way out when the CEO of a multinational corporation offers him a job. It’s a sweet gig as a personal wizard with a fat paycheck. It just has one catch. The paranoid CEO isn’t a mere hypochondriac, he’s been hexed with an authentic ancient curse.<br/><br/> Now Colin is the only thing standing between his new boss and a frozen bundle of fangs, claws, and rage. If he can’t stop the cannibal ice demon in time to save his new boss, it’ll be back to living out of his dead car. That is, if he even survives the battle.</p><b>“Well-researched and creatively presented humor and action perfectly blend with moral quandaries in this outstanding debut.”—<i>Publishers Weekly</i>, Starred Review</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joshua Bader
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      City Owl Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8952c482